import BooleanInput from './BooleanInput'
import DateInput from './DateInput'
import StringInput from './StringInput'
import NumberInput from './NumberInput'
import SelectInput from './SelectInput'
import RadioInput from './RadioInput'
import JsonInput from './JsonInput'
import TextAreaInput from './TextAreaInput'

export default EditableInput = ({ type, props... }) ->
  switch
    when type is 'date'
      <DateInput {props...} />
    when type is 'double'
      <NumberInput {props...} />
    when type is 'boolean'
      <BooleanInput {props...} />
    when type is 'select'
      <SelectInput {props...} />
    when type is 'radio'
      <RadioInput {props...} />
    when type is 'json'
      <JsonInput {props...} />
    when type is 'multiline'
      <TextAreaInput {props... } />
    else
      <StringInput {props...} />
